import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  assignedProjects: [],
  assignedFolders: {},
  assignedFiles: {},
  selectedAssignedProjectId: null,
  selectedAssignedFolderId: null,
  selectedAssignedFileId: null,
  validatorsByLanguage: {},
  selectedFileTargetLanguageId: null,
  devnagariUsers: [],
  devAdminId: null,
  sourceId: null,
  targetlanguageId: null,
  sentences: [],
};

const devnagriValidatorAdminSlice = createSlice({
  name: "devnagriValidatorAdmin",
  initialState,
  reducers: {
    addValidatorAdminDetails: (state, action) => {
      state.validatorAdminDetails = action.payload;
    },
    addValidators: (state, action) => {
      state.validators = action.payload;
    },
    addValidatorsByLanguage: (state, action) => {
      const { languageId, validators } = action.payload;
      state.validatorsByLanguage = {
        ...state.validatorsByLanguage,
        [languageId]: validators,
      };
    },
    setSelectedFileTargetLanguageId: (state, action) => {
      state.selectedFileTargetLanguageId = action.payload;
    },
    addAssignedProjects: (state, action) => {
      state.assignedProjects = action.payload;
    },
    addAssignedFolders: (state, action) => {
      const { projectId, folders } = action.payload;
      state.assignedFolders = {
        ...state.assignedFolders,
        [projectId]: folders,
      };
    },
    addAssignedFiles: (state, action) => {
      const { folderId, files } = action.payload;
      state.assignedFiles = {
        ...state.assignedFiles,
        [folderId]: files,
      };
    },
    setSelectedAssignedProjectId: (state, action) => {
      state.selectedAssignedProjectId = action.payload;
    },
    setSelectedAssignedFolderId: (state, action) => {
      state.selectedAssignedFolderId = action.payload;
    },
    setSelectedAssignedFileId: (state, action) => {
      state.selectedAssignedFileId = action.payload;
    },
    setSelectedFile: (state, action) => {
      state.selectedFile = action.payload;
    },
    setDevnagariUsers: (state, action) => {
      state.devnagariUsers = action.payload;
    },
    setDevAdminId: (state, action) => {
      state.devAdminId = action.payload;
    },
    setSourceId: (state, action) => {
      state.sourceId = action.payload;
    },
    setTargetId: (state, action) => {
      state.targetlanguageId = action.payload;
    },
    setSentences: (state, action) => {
      state.sentences = action.payload;
    },
  },
});

export const {
  addAssignedFiles,
  addAssignedFolders,
  addAssignedProjects,
  addValidatorsByLanguage,
  setSelectedFileTargetLanguageId,
  addTranslatorAdminDetails,
  addTranslators,
  setSelectedAssignedFileId,
  setSelectedAssignedFolderId,
  setSelectedAssignedProjectId,
  setSelectedFile,
  setDevnagariUsers,
  setDevAdminId,
  setSourceId,
  setTargetId,
  setSentences,
} = devnagriValidatorAdminSlice.actions;

export default devnagriValidatorAdminSlice.reducer;
